import React, { useState, useEffect, useRef } from "react";
import LoadingCard from "../../components/LoadingCard";
import CandidateDashboard from "../../layouts/CandidateDashboard";
import moment from "moment";
import { Card, Collapse, message } from "antd";
import swal from "sweetalert";
import "react-image-crop/dist/ReactCrop.css";
import Header from "./components/Header";
import useGetFile from "../../hooks/useGetFile";
import useAuthCandidateToken from "../../hooks/useAuthCandidateToken";
import { UpOutlined, DownOutlined, RightOutlined, SyncOutlined } from "@ant-design/icons";
import ApplicationDetals from "./components/ApplicationDetals";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
// import BlinkButton from "./components/BlinkButton";
import { changeDateAndTimeFormat } from "../../utils/commonFunctions";
import useAxios from "../../hooks/useAxios";

const AGENT_INTERVIEWS = [
  {
    key: "L1",
    label: "L1",
  },
  {
    key: "L2",
    label: "L2",
  },
  {
    key: "final",
    label: "Final",
  },
  {
    key: "versant",
    label: "Versant",
  },
  {
    key: "clientRound",
    label: "Client Round",
  },
];

const { Panel } = Collapse;

function Home() {
  const id = localStorage.getItem("candidate.id");
  const api = useAxios();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [applicationData, setApplicationData] = useState();
  const [s3Files, setS3Files] = useState({
    candidatePhoto: "",
  });
  const { candidateToken } = useAuthCandidateToken();
  const [userData, setUserData] = useState();
  const { getImage } = useGetFile(candidateToken);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefreshTestStatus = async (e) => {
    if (e) e.stopPropagation();
    if (!id) return;
    try {
      setRefreshing(true);
      const { data } = await api.get(`/candidates/${id}`, {
        tokenType: "candidate",
      });
      setUserData(data);
    } catch (err) {
      console.error(err);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (!id) return;

    const loadApp = async () => {
      try {
        setLoading(true);

        const { data } = await api.get(`/candidates/${id}`, {
          tokenType: "candidate",
        });

        const [photo] = await Promise.all([
          getImage(data?.candidatePhoto[0]?.path),
          loadFormList(data?.mobileNo),
        ]);

        setUserData(data);
        setS3Files({
          candidatePhoto: photo,
        });
      } catch (err) {
        console.error(err);
        throw new Error("Some thing went wrong.");
      } finally {
        setLoading(false);
      }
    };

    loadApp();
  }, [id]);

  const loadFormList = async (mobileNo) => {
    try {
      const { data } = await api.get(
        `/candidateDocuments/candidateFormList/${mobileNo}`,
        { tokenType: "candidate" },
      );
      setApplicationData(data.status);
      const filterStatus = data?.status?.find((ele) => {
        return ele.IsSelected === true;
      });
      if (filterStatus?.IsSelected) {
        swal({
          title: "Congratulations!",
          text:
            "You have been selected as an " +
            filterStatus?.trf?.title +
            " in " +
            filterStatus?.trf?.department +
            "," +
            filterStatus?.trf?.location,
          icon: "success",

          dangerMode: true,
        });
      }
    } catch (err) {
      console.error(err);
      throw new Error("Some thing went wrong.");
    }
  };

  const getButtonStatus = (interviewData, totalInterviews, ele) => {

    const IsSelected = ele?.IsSelected;
    if (IsSelected) {
      return true;
    }

    const isNONAgent = ele?.trf?.candidateType === "Non-Agent";

    if (totalInterviews.length !== 0 && isNONAgent) {
      if (interviewData?.length !== totalInterviews?.length) {
        for (let item of interviewData) {
          if (item?.status === "Rejected") {
            return false;
          }
        }
        return undefined;
      }

      if (interviewData?.length === totalInterviews?.length) {
        const isSelected = interviewData?.every(
          (item) => item?.status === "Selected",
        );
        if (isSelected && ele?.sentDocumentStatus === true) {
          return null;
        }

        return undefined;
      }
    } else {
      for (let item of interviewData) {
        if (item?.status === "Rejected") {
          return false;
        }
      }
      const isClientRoundExist = interviewData?.find(
        (item) => item?.type === "versant",
      )?.clientRoundExist;

      const isVersantNotRequired = interviewData?.find(
        (item) => item?.type === "versant",
      )?.isVersantNotRequired;

      if (isClientRoundExist) {
        if (interviewData.length === 4) {
          const isSelected = interviewData?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return null;
          }
        } else {
          return undefined;
        }
      } else {
        if (interviewData.length === 3) {
          const isSelected = interviewData?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return null;
          }
        }
        else if (interviewData.length === 4 && isVersantNotRequired) {
          const isSelected = interviewData?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return null;
          }
        }
        else {
          return undefined;
        }
      }
      return undefined;
    }
  };

  const testStatus = userData?.languageConfidenceScore?.status || null;
  const isTestDone = testStatus === 'completed';
  const testDate = userData?.languageConfidenceScore?.createdAt;

  const candidateFormId = userData?.form?._id || userData?.form || userData?.formId;
  const LATERAL_FORM_IDS = ["633190214529e62d9edc2fff", "62e91154309f9f7d5806d044"];
  const isNonAgentForm = LATERAL_FORM_IDS.includes(String(candidateFormId));
  const isNonAgent = userData?.trf?.candidateType === "Non-Agent" || isNonAgentForm;

  const getStatusBadge = () => {
    switch (testStatus) {
      case 'completed':
        return (
          <span
            className="px-2"
            style={{
              fontSize: "12px",
              border: "1px solid green",
              borderRadius: "10px",
              color: "green",
              fontWeight: "700",
            }}
          >
            Completed
          </span>
        );
      case 'pending':
        return (
          <div className="d-flex align-items-center gap-2">
            <span
              className="px-2"
              style={{
                fontSize: "12px",
                border: "1px solid orange",
                borderRadius: "10px",
                color: "orange",
                fontWeight: "700",
              }}
            >
              In Progress
            </span>
            <SyncOutlined
              spin={refreshing}
              onClick={handleRefreshTestStatus}
              style={{ color: '#1890ff', cursor: 'pointer', fontSize: '14px' }}
              title="Refresh Status"
            />
          </div>
        );
      case 'failed':
        return (
          <span
            className="px-2"
            style={{
              fontSize: "12px",
              border: "1px solid red",
              borderRadius: "10px",
              color: "red",
              fontWeight: "700",
            }}
          >
            Re-do the test
          </span>
        );
      default:
        return (
          <span
            className="px-2"
            style={{
              fontSize: "12px",
              border: "1px solid grey",
              borderRadius: "10px",
              color: "grey",
              fontWeight: "700",
            }}
          >
            Pending
          </span>
        );
    }
  };

  return (
    <CandidateDashboard>
      {loading ? (
        <div className="container">
          <LoadingCard />
        </div>
      ) : (
        <>
          <div
            class="container main-container mt-3"
            style={{ minHeight: "84vh" }}
          >
            <Header
              name={userData?.name}
              email={userData?.email}
              candidatePhoto={s3Files?.candidatePhoto}
            />
            {applicationData?.map((ele) => {
              if (ele?.interviewDetails) {
                const { interviewData, totalInterviews } =
                  ele?.interviewDetails;
                const lastArrangeInterview = interviewData?.find(
                  (item) => item?.finished === false,
                );
                if (lastArrangeInterview) {
                  const Founded = totalInterviews?.find(
                    (item) =>
                      item?._id ===
                      lastArrangeInterview?.designationInterviewsNamesMappingId,
                  );
                  return (
                    <div class="card mt-3 card-highlight p-3">
                      <h5>Upcoming Interview</h5>
                      <div class="separator"></div>
                      <h6>&nbsp;{ele?.trf?.title}</h6>
                      <div class="row mt-1">
                        <div class="col-2 col-sm-1 d-flex">
                          <img src="/img/calender.svg" height="45" alt="" />
                        </div>
                        <div class="col-10 col-sm-11 pl-0">
                          <h5 class="fw-bold fs-5">
                            {Founded
                              ? `Interview Round`
                              : AGENT_INTERVIEWS?.find(
                                (item) =>
                                  item?.key === lastArrangeInterview?.type,
                              )?.label}{" "}
                            (In Person)
                          </h5>
                          <p>
                            {moment(lastArrangeInterview?.start).format(
                              "MMMM D, YYYY - h:mm A",
                            )}
                          </p>
                          <hr />
                          <p class="d-flex justify-content-between">
                            Khasra 75, Kochar Business Park, 2nd Floor, 19,
                            Manawala Rd, Amritsar, Punjab 143115
                            <div className="d-flex flex-column align-items-center">
                              <img src="/img/map.svg" height="45" alt="" />
                              <a
                                href={`http://www.google.com/maps/place/${"31.5899435"},${"74.9608504"}`}
                                target="_blank"
                              >
                                {" "}
                                [Map]
                              </a>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }
              }
            })}
            <div class="mt-3">
              {!isNonAgent && (
                <div
                  className="px-3 py-2 bg-white d-flex justify-content-between"
                  style={{ border: "1px solid #d9d9d9" }}
                >
                  <span class="ant-collapse-header-text">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="font-weight-bold">
                        Communication Assessment
                      </div>
                    </div>
                    <div className="d-flex gap-1 mt-1">
                      <span>
                        {testDate ? changeDateAndTimeFormat(testDate) : "NA"}
                      </span>
                      {getStatusBadge()}
                    </div>
                  </span>
                  <div class="d-flex">
                    <button
                      class="d-flex justify-content-center align-items-center"
                      onClick={() => {
                        if (testStatus === 'completed') {
                          return message.error("You have already completed this test. Reattempting is not permitted.", 2);
                        }
                        if (testStatus === 'pending') {
                          return message.info("Test is currently being processed. Please wait.", 2);
                        }
                        history.push(`/language-confidence`);
                      }}
                    >
                      <RightOutlined style={{ fontSize: "1.5rem" }} />
                    </button>
                  </div>
                </div>
              )}

              <Collapse
                expandIconPosition="right"
                size="large"
                className="mt-2"
                expandIcon={({ isActive }) =>
                  isActive ? <UpOutlined /> : <DownOutlined />
                }
                style={{ position: "relative" }}
                accordion
              >
                {applicationData?.map((ele) => {
                  const { interviewData, totalInterviews } =
                    ele?.interviewDetails;
                  const status = getButtonStatus(
                    interviewData,
                    totalInterviews,
                    ele,
                  );
                  return (
                    <Panel
                      header={
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="mb-2 font-weight-bold">
                            {ele?.trf?.title || "No interviews lined up."}
                          </div>
                          <div className="d-flex">
                            {status === undefined &&
                              ele?.isDocumentSent === false && (
                                <>
                                  <span class="in-progress-btn d-flex justify-content-center align-items-center">
                                    In Progress
                                  </span>
                                  {(() => {
                                    const l1Interview = Array.isArray(interviewData)
                                      ? interviewData.find((i) => i.type === "L1")
                                      : null;
                                    const isPhygitalL1Selected = Boolean(
                                      (ele?.L1_Status === "Selected" || l1Interview?.status === "Selected") &&
                                      (
                                        l1Interview?.phygitalVerification?.bestFrameImageUrl ||
                                        l1Interview?.phygitalVerification?.candidateJoined === true

                                      )
                                    );
                                    if (isPhygitalL1Selected) return null;
                                    return (
                                      <button
                                        style={{ width: "70px" }}
                                        className={`btn-sm font-weight-bold ${"btn-primary"}`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          history.push(
                                            `/update-candidate/${ele?.form?._id}/${ele?._id}/long-form`,
                                          );
                                        }}
                                      >
                                        Edit
                                      </button>
                                    );
                                  })()}
                                </>
                              )}
                            {(status === null ||
                              ele?.isDocumentSent === true) &&
                              ele?.IsSelected === false && (
                                <Link
                                  to={`/careers/view/${ele?._id}`}
                                  class="in-progress-btn d-flex justify-content-center align-items-center"
                                >
                                  Document Process
                                </Link>
                              )}
                            {status === true && (
                              <Link
                                to={`/careers/view/${ele?._id}`}
                                class="onboard-btn d-flex justify-content-center align-items-center"
                              >
                                Onboarded
                              </Link>
                            )}
                            {status === false && (
                              <span class="rejected-btn">Rejected</span>
                            )}
                            {/* {!ele?.isEmpTempIdCreated && (
                              // <BlinkButton
                              //   candidateId={ele?._id}
                              //   formId={ele?.form?._id}
                              // />
                            )} */}
                          </div>
                        </div>
                      }
                      key={ele?._id}
                    >
                      <ApplicationDetals
                        key={ele?._id}
                        data={ele}
                        AGENT_INTERVIEWS={AGENT_INTERVIEWS}
                      />
                    </Panel>
                  );
                })}
              </Collapse>

              <div class="card mt-3 p-3">
                <h6>Learn About Maxicus</h6>
                <div class="d-flex gap-1">
                  <img src="/img/external-link.svg" height="20" alt="" />
                  <a
                    href="https://maxicus.com/"
                    class="d-block"
                    target="_blank"
                    style={{ textDecoration: "underline" }}
                  >
                    About Maxicus
                  </a>
                </div>
                <div class="d-flex gap-1">
                  <img src="/img/external-link.svg" height="20" alt="" />
                  <a
                    href="https://maxicus.com/careers/"
                    class="d-block"
                    target="_blank"
                    style={{ textDecoration: "underline" }}
                  >
                    Careers @ Maxicus
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </CandidateDashboard>
  );
}

export default Home;
